export default __webpack_public_path__ + "static/media/mastercard.c85db9bd.svg";